import cloneDeepWith from 'lodash.clonedeepwith';
import mergeWith from 'lodash.mergewith';
import { DeepPartial } from '@nx-frontend/shared/types/utils';

export function patchObject<T extends object = object>(a: T, b: DeepPartial<T>, cloneDeep = false): T {
  return mergeWith(cloneDeep ? cloneDeepWith(a) : { ...a }, { ...b }, (_, b) => (Array.isArray(b) ? b : undefined));
}

export function patchObjectMulti<T extends object = object>(a: T, bArr: DeepPartial<T>[], cloneDeep = false): T {
  let result = { ...a };
  for (const b of bArr) {
    result = patchObject<T>(a, b, cloneDeep);
  }
  return result;
}
